import { RevealButton } from "./RevealButton";

export * from "./RevealButton";

export default RevealButton;
